import styled from "styled-components"
import { createStyledText } from "./Text"

const Container = styled.input`
  width: 100%;
  min-height: 50px;
  padding: 8px 16px;
  background-color: ${(props) => props.theme.colors.neutral[100]}; 
  outline: none; // 기본 css 설정 초기화
  border: 1px solid ${(props) => (props.$error ? props.theme.colors.status.error : props.theme.colors.neutral[400])};
  border-radius: 10px;

  &:focus {
    border-color: ${(props) =>
      props.readOnly
        ? props.theme.colors.neutral[400]
        : props.$error
        ? props.theme.colors.status.error
        : props.theme.colors.primary};
  }

  &:active {
    border-color: ${(props) =>
      props.readOnly
        ? props.theme.colors.neutral[400]
        : props.$error
        ? props.theme.colors.status.error
        : props.theme.colors.primary};
  }
        
  cursor: ${({ readOnly }) => (readOnly ? "default" : "text")};

  // input value 텍스트 설정
  ${({ theme }) =>
    createStyledText({ theme })}

  // placeholder 텍스트 설정
  &::placeholder {
    ${({ theme }) =>
      createStyledText({ theme, color: "assistive" })}
  }

  // 자동완성 시 파란색 배경 제거
  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
    -webkit-text-fill-color: ${(props) => props.theme.colors.text.normal}; 
    transition: background-color 5000s ease-in-out 0s;
    box-shadow: 0 0 0px 1000px ${(props) => props.theme.colors.neutral[100]} inset !important;
  }
`

const BaseInput = ({ placeholder, value, onChange, $error, $hasValue, ...props }) => {
  return (
    <Container
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      $error={$error}
      {...props}
    />
  );
};

export default BaseInput
